import { ApplicationDetailScreen } from "@/features/staff/applications";

export default ApplicationDetailScreen;
